import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import SafeImage from "../components/SafeImage";

export default function Home() {
  const { content } = useContent();
  const h = content.home || {};
  const slides = h.slideshow && h.slideshow.length > 0 ? h.slideshow : [];
  const [currentIndex, setCurrentIndex] = useState(0);
  const heroSlide = slides[currentIndex] || slides[0];

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  useEffect(() => {
    if (currentIndex >= slides.length) setCurrentIndex(0);
  }, [slides.length, currentIndex]);

  return (
    <div className="premium-home">
      <section className="premium-hero position-relative">
        {(slides.length > 0 ? slides : [{ src: h.heroImage || "", caption: "" }]).map((slide, index) => (
          <div
            key={`${index}-${slide.src || "slide"}`}
            className={`premium-hero-slide ${index === currentIndex ? "active" : ""}`}
          >
            <SafeImage
              src={slide?.src || h.heroImage || ""}
              alt={slide?.caption || "Himmelstor Farm Landscape"}
              className="premium-hero-image"
            />
          </div>
        ))}
        <div className="premium-hero-overlay">
          <div className="text-center text-white px-3">
            <h2 className="premium-hero-heading">{h.heroTitle || "Born to Farm"}</h2>
            <p className="premium-hero-subheading">
              {heroSlide?.caption || "Sustainable Farming • Zimbabwe"}
            </p>
          </div>
        </div>
        {slides.length > 1 && (
          <div className="premium-hero-dots">
            {slides.map((_, idx) => (
              <button
                key={`dot-${idx}`}
                type="button"
                className={`premium-hero-dot ${idx === currentIndex ? "active" : ""}`}
                onClick={() => setCurrentIndex(idx)}
                aria-label={`Go to slide ${idx + 1}`}
              />
            ))}
          </div>
        )}
      </section>

      <section className="container-xxl px-3 px-md-5 premium-overlap-section">
        <div className="row g-4 align-items-center">
          <div className="col-lg-7">
            <div className="premium-overlap-image-wrap">
              <SafeImage
                src={h.heroImage || heroSlide?.src || ""}
                alt="Farm Vision"
                className="premium-overlap-image"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="premium-overlap-card">
              <h3 className="premium-section-title">{h.heroTitle || "Born to Farm"}</h3>
              <p className="text-muted mb-4">{h.heroSubtext || ""}</p>
              <div className="d-flex flex-wrap gap-2">
                <Link to="/agro-tourism" className="btn premium-btn-primary">Book a Visit</Link>
                <Link to="/products" className="btn premium-btn-outline">Our Products</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="container py-5">
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card h-100 border-0 shadow-sm premium-feature-card">
              <div className="card-body p-4">
                <h5 className="premium-feature-title">{h.card1Title || "Products"}</h5>
                <p className="card-text">{h.card1Text || ""}</p>
                <Link to="/products" className="btn btn-link px-0 text-farm-gold">Learn More</Link>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card h-100 border-0 shadow-sm premium-feature-card">
              <div className="card-body p-4">
                <h5 className="premium-feature-title">{h.card2Title || "Consulting"}</h5>
                <p className="card-text">{h.card2Text || ""}</p>
                <Link to="/services" className="btn btn-link px-0 text-farm-gold">Learn More</Link>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card h-100 border-0 shadow-sm premium-feature-card">
              <div className="card-body p-4">
                <h5 className="premium-feature-title">{h.card3Title || "Agro-Tourism"}</h5>
                <p className="card-text">{h.card3Text || ""}</p>
                <Link to="/agro-tourism" className="btn btn-link px-0 text-farm-gold">Learn More</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
